import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 30px 0 90px;
  text-align: center;
`;

export const Title = styled.div`
  font-size: 36px;
  font-weight: 700;
  color: ${(props: any) => props.theme.carvana.blue.dark};
`;

export const Text = styled.div`
  color: ${(props: any) => props.theme.carvana.gray.dark};
`;

export const Img = styled.img`
  margin-top: 20px;
  width: 118px;
`;
